import React from "react";
import { Badge } from "react-bootstrap";

// Values of erp_sync_status sent by the OMS franchise_list
// (DealerErpSync in em-biz-backend order/constants.py).
const ERP_SYNC_LABELS = {
    synced: { bg: "success", label: "In ERP" },
    failed: { bg: "danger", label: "ERP refused" },
    not_linked: { bg: "warning", text: "dark", label: "In ERP, not linked" },
    not_tried: { bg: "secondary", label: "Not sent yet" },
};

// A dealer's ERP sync state, with the ERP's reason when it is not in the ERP.
// The reason is server text and renders as text.
const ErpSyncStatus = ({ status, reason }) => {
    const state = ERP_SYNC_LABELS[status];
    if (!state) {
        return "-";
    }
    return (
        <div style={{ minWidth: "160px", maxWidth: "320px", whiteSpace: "normal" }}>
            <Badge bg={state.bg} text={state.text}>{state.label}</Badge>
            {reason && <div className="small text-muted mt-1">{reason}</div>}
        </div>
    );
};

export default ErpSyncStatus;
